import React from 'react';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './WalkInInstructions.module.scss';

const WalkInInstructions = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="Voucher"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.title}>{t('checkout.walkInInstructions.title')}</div>
      <div className={CN.container}>
        <span className={CN.item}>{t('checkout.walkInInstructions.step1')}</span>
        <span className={CN.item}>{t('checkout.walkInInstructions.step2')}</span>
        <span className={CN.item}>{t('checkout.walkInInstructions.step3')}</span>
        <span className={CN.item}>{t('checkout.walkInInstructions.step4')}</span>
      </div>
    </div>
  );
};

export default WalkInInstructions;
